import React from 'react';
import './PolToast.scss';

export default function PolToast({children}) {
    return (
        <div className="pol-toast">
            <div className="pol-toast__content">
                {children}
            </div>
        </div>
    )
}
